export default __webpack_public_path__ + "hide-svgrepo-com.0d29b24d.svg";